import { render, staticRenderFns } from "./ServerTotalPriceAndInfo.vue?vue&type=template&id=34fb7932&scoped=true&"
import script from "./server-total-price-and-info.js?vue&type=script&lang=js&"
export * from "./server-total-price-and-info.js?vue&type=script&lang=js&"
import style0 from "./server-total-price-and-info.scss?vue&type=style&index=0&id=34fb7932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb7932",
  null
  
)

export default component.exports